import type { FC } from "react";

import { useSelector } from "react-redux";

import { translate } from "app/filters/i18nFilter";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { selectIntentSelectedTopics } from "app/pages/sales-intelligence/sub-modules/intent/store/management/selectors/selectors";
import type { Topic } from "app/pages/sales-intelligence/sub-modules/intent/types/common";

import AddTopicView from "../AddTopicView/AddTopicView";
import IntentSelectedTopicView from "../IntentSelectedTopicView/IntentSelectedTopicView";

import {
    StyledIntentHeader,
    StyledIntentMainBlock,
    StyledIntentSubHeader,
    StyledIntentSubHeaderBlock,
    StyledIntentTopicBlock,
    StyledIntentTopicContainer,
    StyledIntentTopicSelectedContainer,
    StyledIntentTopicViewIcon,
    StyledIntentTopicViewLink,
} from "./styles";

const IntentTopicView: FC = () => {
    const selectedTopics: readonly Topic[] = useSelector(selectIntentSelectedTopics);
    const isHighLevelAccount = salesSettingsHelper.isHighLevelAccount();

    return (
        <StyledIntentTopicBlock>
            <div>
                <StyledIntentHeader>{translate("si.intent.management.header")}</StyledIntentHeader>
                <StyledIntentSubHeaderBlock>
                    <StyledIntentSubHeader>
                        {isHighLevelAccount
                            ? translate("si.intent.management.header.description")
                            : translate("si.intent.management.header.user.description")}
                    </StyledIntentSubHeader>
                    <StyledIntentTopicViewLink
                        href="https://support.similarweb.com/hc/en-us/articles/14234221556509"
                        target="_blank"
                    >
                        {translate("si.signals.traffic-changes.learnMore")}
                        <StyledIntentTopicViewIcon
                            iconName="link-out"
                            size="xs"
                        />
                    </StyledIntentTopicViewLink>
                </StyledIntentSubHeaderBlock>
            </div>

            <StyledIntentMainBlock>
                <StyledIntentTopicContainer>
                    <AddTopicView />
                </StyledIntentTopicContainer>
                <StyledIntentTopicSelectedContainer>
                    <IntentSelectedTopicView />
                </StyledIntentTopicSelectedContainer>
            </StyledIntentMainBlock>
        </StyledIntentTopicBlock>
    );
};

export default IntentTopicView;
